import React from "react";

const ThumbnailNavigation = ({
  quizzes,
  currentIndex,
  userAnswers,
  showUnansweredHighlights,
  onThumbnailClick,
}) => {
  return (
    <div className="thumbnail-navigation-wrapper">
      <div className="thumbnail-navigation">
        {quizzes.map((q, index) => (
          <div
            key={index}
            className={`thumbnail-nav-item
              ${index === currentIndex ? "active" : ""}
              ${
                showUnansweredHighlights && userAnswers[index] === undefined
                  ? "unanswered"
                  : ""
              }
            `}
            onClick={() => onThumbnailClick(index)}
          >
            <div className="quiz-thumbnail-number">#{index + 1}</div>
            <img
              src={q.image_url}
              alt={q.headline}
              className="thumbnail-img-small"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThumbnailNavigation;
